import apiClient from './api.service';

export interface SiteStockRow {
  warehouse_id: string;
  warehouse_code: string;
  warehouse_name: string;
  item_id: string;
  item_code: string;
  item_name: string;
  heat_number: string;
  dimension: string;
  uom: string;
  available_qty: number;
  average_cost: number;
  total_value: number;
}

export interface SiteStockResponse {
  project_id: string;
  project_code?: string;
  rows: SiteStockRow[];
}

class SiteMaterialService {
  async getSiteStock(projectId: string, filters?: { warehouse_id?: string; item_id?: string }) {
    const params = new URLSearchParams();
    params.append('project_id', projectId);
    if (filters?.warehouse_id) params.append('warehouse_id', filters.warehouse_id);
    if (filters?.item_id) params.append('item_id', filters.item_id);
    const response = await apiClient.get(`/inventory/site-stock?${params.toString()}`);
    return (response.data || response) as SiteStockResponse;
  }

  async consume(payload: {
    project_id: string;
    warehouse_id: string;
    department_id: string;
    notes?: string;
    lines: Array<{
      item_id: string;
      quantity: number;
      uom?: string;
      heat_number?: string | null;
      dimension?: string | null;
      unit_cost?: number;
      notes?: string;
    }>;
  }) {
    const response = await apiClient.post('/inventory/site-consumptions', payload);
    return response.data || response;
  }

  async focReceipt(payload: {
    project_id: string;
    warehouse_id: string;
    notes?: string;
    supply_kind?: 'OwnerSupplied' | 'SubconFreeIssue';
    reference_id?: string;
    lines: Array<{
      item_id: string;
      quantity: number;
      uom?: string;
      heat_number?: string | null;
      dimension?: string | null;
      notes?: string;
    }>;
  }) {
    const response = await apiClient.post('/inventory/site-foc-receipts', payload);
    return response.data || response;
  }

  async allocateIcToProjectWip(
    icTransactionId: string,
    payload: { buyer_project_id: string; to_warehouse_id?: string }
  ) {
    const response = await apiClient.post(
      `/intercompany/transactions/${icTransactionId}/allocate-to-project-wip`,
      payload
    );
    return response.data || response;
  }
}

export default new SiteMaterialService();
